import React from 'react';
import { getScenarioLucideIcon } from './scenarioIcons';

// SVG icon paths for scenarios
const scenarioIconPaths = {
  'teknologia': '/assets/icons/technology.svg',
  'väestö': '/assets/icons/population.svg',
  'demokratia': '/assets/icons/democracy.svg',
  'ilmasto': '/assets/icons/climate.svg',
};

function getScenarioIconPath(title) {
  if (!title) return null;
  const normalized = title.toLowerCase().trim();
  if (scenarioIconPaths[normalized]) return scenarioIconPaths[normalized];
  for (const [key, path] of Object.entries(scenarioIconPaths)) {
    if (normalized.includes(key) || key.includes(normalized)) return path;
  }
  return null;
}

// Lucide first: it draws in currentColor at a 2px stroke. The brand SVGs are a
// 100-unit viewBox with a 1-unit stroke, which at 16px is a hairline that reads
// as dim grey no matter what colour it is given.
export default function ScenarioIcon({ title, icon }) {
  const LucideIcon = getScenarioLucideIcon(title, icon);
  if (LucideIcon) return <LucideIcon size={16} strokeWidth={2} />;
  const svgPath = title ? getScenarioIconPath(title) : null;
  if (svgPath) {
    return (
      <img
        src={svgPath}
        alt=""
        style={{ width: 16, height: 16, filter: 'brightness(0) invert(1)' }}
      />
    );
  }
  return null;
}
